import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { get } from '../../util/request'
import { useSelector } from 'react-redux'
import { format } from 'date-fns'

const DetailInfo = (props) => {
	const { id } = useParams()
	const [state, setState] = useState({
		infoDetail: '',
		startDate: format(new Date(), "yyyy-MM-dd"),
		dateForm: {
			startDate: '',
			endDate: '',
		},
		loading: true
	})

	const jwtToken = useSelector(state => state.auth.generateToken)
	const user = useSelector(state => state.auth.user)

	useEffect(() => {
		let isMounted = true
		if (isMounted) {

			getInfoList()
		}
		return () => isMounted === false
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const getInfoList = () => {
		get(
			`public/api/v1/info-detail?companyId=${user.company_id}&info_id=${id}`,
			{
				headers: {
					Authorization: `Bearer ${jwtToken}`,
					'Content-Type': 'application/json'
				},
			},
			success => {
				console.log(success.data.Data)
				setState(prevState => {
					return {
						...prevState,
						// tasksList: success.data.Data,
						infoDetail: success.data.Data,
						loading: false
					}
				})
			},
			error => {
				setState(prevState => {
					return {
						...prevState,
						loading: false
					}
				})
				console.log('error request', error)
			}
		)
	}
	return (
		state.loading ? '' :
			<div className='w-full h-screen grid-cols-1 sm:grid-cols-2 bg-bg-primary'>
				<div className='w-full h-20 bg-real-white'>
					<div className='flex items-center h-full px-4'>
						<a href={process.env.PUBLIC_URL + "/info"}>
							<img alt='logo_home' src={process.env.PUBLIC_URL + "/assets/img/arrow-left.svg"} className='justify-start w-10 py-1' />
						</a>
						<p className='px-4'>Detail Berita</p>
					</div>
				</div>
				<div className='grid w-full grid-cols-1 bg-real-white'>
					<div className='h-full mx-4'>
						<p className='text-lg font-bold text-red-bg'>{state.infoDetail.title}</p>
						<p className='mt-4 text-xs'>{state.infoDetail.tanggal}</p>
						<img alt='logo_home' src={state.infoDetail.image_url} className='w-full py-4 sm:w-1/4 sm:mx-auto' />
						<p className='mt-4 text-xs'>{state.infoDetail.sub_title}</p>
						<p className='mt-4 text-sm font-bold'>Tanggal Mulai: {state.infoDetail.tanggal_mulai}</p>
						<p className='mt-4 text-sm font-bold'>Tanggal Berakhir: {state.infoDetail.tanggal_berakhir}</p>
						<p className='pb-10 mt-4 text-xs'>{state.infoDetail.content}</p>
					</div>
				</div>




			</div >
	)
}

export default DetailInfo